import React from 'react';
import FundingLenderStatusBadge from './FundingLenderStatusBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const FundingLenderProductTable = ({ products, canEdit, onDelete, deletingId }) => {
  if (!products?.length) {
    return <p className="text-sm text-[var(--fg-muted)]">No products configured for this lender.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-left text-sm">
        <thead>
          <tr className="border-b border-[var(--fg-line)] text-[var(--fg-muted)]">
            <th className="px-3 py-2">Product</th>
            <th className="px-3 py-2">Amount range</th>
            <th className="px-3 py-2">Criteria</th>
            <th className="px-3 py-2">Estimated speed</th>
            <th className="px-3 py-2">Status</th>
            {canEdit ? <th className="px-3 py-2" /> : null}
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id || product.productType} className="border-b border-[var(--fg-line)]/70">
              <td className="px-3 py-3">
                <div className="font-medium text-[var(--fg-text)]">{product.name || product.productType}</div>
                <div className="text-xs text-[var(--fg-muted)]">{product.productType}</div>
              </td>
              <td className="px-3 py-3 text-[var(--fg-muted)]">
                {formatCurrency(product.minAmount)} – {formatCurrency(product.maxAmount)}
              </td>
              <td className="px-3 py-3 text-[var(--fg-muted)]">
                {product.minCreditScore ? `${product.minCreditScore}+ credit` : '—'}
              </td>
              <td className="px-3 py-3 text-[var(--fg-muted)]">
                {product.estimatedSpeedDays != null ? `${product.estimatedSpeedDays} days` : '—'}
              </td>
              <td className="px-3 py-3"><FundingLenderStatusBadge status={product.status} /></td>
              {canEdit ? (
                <td className="px-3 py-3 text-right">
                  <button
                    type="button"
                    className="text-sm text-rose-600 hover:underline disabled:opacity-50"
                    disabled={deletingId === product.id}
                    onClick={() => onDelete?.(product)}
                  >
                    {deletingId === product.id ? 'Removing...' : 'Remove'}
                  </button>
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FundingLenderProductTable;
